import AdsContainer from "@components/Blocks/Container/AdsContainer";
import { READ_MORE_CTA_COPY } from "@config/ctaCopy";
import ArticleElementWrapper from "@pages/Article/Components/ArticleElementWrapper";
import React from "react";

import HardRegBanner from "../HardRegBanner";
import RegistrationBanner from "../RegistrationBanner";
import SubscriptionBanner from "../SubscriptionBanner";
import ReadMoreButton from "./ReadMoreButton";

type InsertionProps = {
  paragraphCount: number;
  adsImu1: React.ReactNode;
  adsMidArticle: React.ReactNode;
  pageNumber: number;
  isInfiniteScrollArticle: boolean;
  showSubBanner: boolean;
  showGenGSubBanner: boolean;
  showRegBanner: boolean;
  showReg2Banner: boolean;
  showFullPara: boolean;
  handleReadMoreClick: () => void;
};

export function getAdAndBannerInsertions({
  paragraphCount,
  adsImu1,
  adsMidArticle,
  pageNumber,
  isInfiniteScrollArticle,
  showSubBanner,
  showGenGSubBanner,
  showRegBanner,
  showReg2Banner,
  showFullPara,
  handleReadMoreClick,
}: InsertionProps): React.ReactNode {
  switch (paragraphCount) {
    case 0:
      return (
        <>
          {showGenGSubBanner && (
            <>
              <ArticleElementWrapper>
                <SubscriptionBanner
                  isInfiniteScrollArticle={isInfiniteScrollArticle}
                  pageNumber={pageNumber}
                  isGenG
                />
              </ArticleElementWrapper>
              <AdsContainer className="my-6 lg:my-8">{adsImu1}</AdsContainer>
            </>
          )}
        </>
      );

    case 1:
      return (
        <>
          {showSubBanner && (
            <>
              <ArticleElementWrapper>
                <SubscriptionBanner
                  isInfiniteScrollArticle={isInfiniteScrollArticle}
                  pageNumber={pageNumber}
                />
              </ArticleElementWrapper>
              <AdsContainer className="my-6 lg:my-8">{adsImu1}</AdsContainer>
            </>
          )}
          {showRegBanner && (
            <>
              <ArticleElementWrapper>
                <RegistrationBanner
                  isInfiniteScrollArticle={isInfiniteScrollArticle}
                  pageNumber={pageNumber}
                />
              </ArticleElementWrapper>
              <AdsContainer className="my-6 lg:my-8">{adsImu1}</AdsContainer>
            </>
          )}
          {showReg2Banner && (
            <>
              <ArticleElementWrapper>
                <HardRegBanner
                  isInfiniteScrollArticle={isInfiniteScrollArticle}
                  pageNumber={pageNumber}
                />
              </ArticleElementWrapper>
              <AdsContainer className="my-6 lg:my-8">{adsImu1}</AdsContainer>
            </>
          )}
        </>
      );

    case 2:
      return (
        <>
          {isInfiniteScrollArticle &&
            !showFullPara &&
            !showReg2Banner &&
            !showRegBanner &&
            !showSubBanner &&
            !showGenGSubBanner && (
              <ReadMoreButton
                label={READ_MORE_CTA_COPY}
                onClick={handleReadMoreClick}
              />
            )}
          <AdsContainer className="mb-6 lg:mb-8">{adsImu1}</AdsContainer>
        </>
      );

    case 5:
      return (
        <AdsContainer className="mb-6 lg:mb-8">{adsMidArticle}</AdsContainer>
      );

    default:
      return null;
  }
}
